import { Link } from "react-router-dom";
import { useTree } from "../data/usePage.js";
import { useRepo, repoHref } from "../data/repo.js";
import { SystemPage } from "./SystemPage.js";

export function TreeView() {
  const repo = useRepo();
  const tree = useTree(repo);

  if (tree.status === "loading") return null;
  if (tree.status === "error")
    return <pre className="dw-error">{tree.error.message}</pre>;

  const files = tree.data.files;
  return (
    <SystemPage title={`Browse ${repo}`}>
      {files.length === 0 ? (
        <p>The checkout is empty or not yet cloned.</p>
      ) : (
        <ul className="dw-tree">
          {files.map((f) => (
            <li key={f}>
              <Link to={repoHref(repo, f.replace(/\.md$/, ""))}>{f}</Link>
            </li>
          ))}
        </ul>
      )}
    </SystemPage>
  );
}
